export enum ProjectOverviewViewEnum {
  Active,
  Previous,
  Summary,
}

export type ProjectOverviewView =
  | ProjectOverviewViewEnum.Active
  | ProjectOverviewViewEnum.Previous
  | ProjectOverviewViewEnum.Summary;
